enum AppType {
  CollectionView = "CollectionView",
}
export default AppType;
